import { Box, Button, ButtonsGroup, Grid, InputSelect, InputText } from "#/atoms";
import { FC, memo, useCallback } from "react";
import { useInput, useInputSelect } from "@/hooks";

import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";
import { ServiceNotesProps } from "./ServiceNotes.interface";
import { StyledServiceNoteCell } from "./ServiceNotes.styled";
import { formatShortDateWithTimeString } from "@/helpers";
import { useApi } from "@/api";

const ServiceNotes: FC<ServiceNotesProps> = ({ isCustomer = true, notifications, onClose, orderServiceId, title }) => {

  const comment = useInput('') ;
  const visible = useInputSelect('visible', false);
  const sendEmail = useInputSelect('sendEmail', false);

  const { order } = useApi();

  const handleAddNote = useCallback(async () => {
    if (isCustomer){
      await order.createOrderNoteCustomer(orderServiceId, comment.value);
    }
    else {
      await order.createOrderNote(orderServiceId, comment.value, visible.checked, sendEmail.checked);
    }
    comment.setValue('');
  }, [comment.value]);

  return (
    <Modal onClose={onClose} title={title} width="800px">
      <Grid gridTemplateColumns="1fr 1.5fr 2fr" margin="10px 0px">
        <div><strong>UserName</strong></div>
        <div><strong>Date</strong></div>
        <div><strong>Message</strong></div>
      { notifications.map((n) => {
        return (<>
          <StyledServiceNoteCell>{n.userName}</StyledServiceNoteCell>
          <StyledServiceNoteCell>{formatShortDateWithTimeString(n.createdDateTime)}</StyledServiceNoteCell>
          <StyledServiceNoteCell>{n.message}</StyledServiceNoteCell>
          </>);
      }) }
      </Grid>
      <Grid>
        <InputText type="text" label="Service note" value={comment.value} onChange={comment.onChange} />
        {!isCustomer && <Box display="flex" style={{ gap: '10px' }}>
          <InputSelect style={{ display: "inline-block"}} type="checkbox" checked={visible.checked} label="Visible to Customer" value={visible.value} onChangeValue={visible.onChange} />
          <InputSelect style={{ display: "inline-block"}}  type="checkbox" checked={sendEmail.checked} label="Also send via Email" value={sendEmail.value} onChangeValue={sendEmail.onChange} />
        </Box> }
      </Grid>
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button onClick={handleAddNote} state={comment.value ? 'default' : 'disabled'}>Add Note</Button>
        <Button onClick={onClose}>Cancel</Button>
      </ButtonsGroup>
    </Modal>
  );
};

export default memo(ServiceNotes);